import store from "../../../../store";
import { has } from "../../../../utils/menu-context";
import { commonInputPropField } from "../../inform/request/request.condition";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (record.createBy === store.state.resource.auth.info.user?.username
                // || (record.createBy === "anonymousUser" && record.refHcTemp?.refUser?.username === store.state.resource.auth.info.user?.username)
                || (record.refHcTemp?.refUser?.username === store.state.resource.auth.info.user?.username)
            ) {
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canArchive: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canArchive" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canWaitReceive: ({ record }) => {
            let result = false;
            if (
                (record.createBy === store.state.resource.auth.info.user?.username ||
                    (record.createBy === "anonymousUser" &&
                        record.refHcTemp?.refUser?.username === store.state.resource.auth.info.user?.username)) &&
                !record.isOfficerCreate
            ) {
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canWaitApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (record.isOfficerCreate) {
                if (["draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canConfirm: ({ record }) => {
            let result = false;
            if (record.createBy === store.state.resource.auth.info.user?.username) {
                if (["waitApprove"].includes(record.refStatus?.key) && record.refHcTemp.isConfirm) {
                    result = true || result;
                }
            }
            return result;
        },
        canReStatus: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canReport: ({ record }) => {
            return !["draft"].includes(record.refStatus?.key);
        }
    };
};

export const createConditionForm = ({ dataKey }) => {
    const prefix = dataKey ? `${dataKey}.` : "";
    const prefixRegExp = dataKey ? `${dataKey}\\.` : "";
    return [
        {
            check: ({ field }) => {
                return [
                    `${prefix}refDepartment.nameEn`,
                    `${prefix}lastStatus.waitReceive.0.statusDatetime`,
                    `${prefix}lastStatus.draft.0.statusDatetime`,
                    `${prefix}lastStatus.waitApprove.0.statusDatetime`,
                    `${prefix}refHcTemp.refUserCompany.companyNameEn`,
                    `${prefix}refHcTemp.refUser.fullNameEn`,
                    `${prefix}refHcTemp.refUserCompany.addresses.0.addrTh`,
                    `${prefix}refHcTemp.refUser.addresses.0.addrTh`
                ].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [`${prefix}refHcTemp.refUserCompany.idCard`].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [`${prefix}refHcTemp.refUser.idCard`].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [`${prefix}refRequestType`].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return [`${prefix}refDocGenType`, `${prefix}requestCode`].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficerCreate;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return [`${prefix}refHcTemp.approveCode`].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficerCreate;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return [`${prefix}refHcTemp.refUserCompany`, `${prefix}refDepartment`].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return [`${prefix}refHcTemp.refUser`].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return [`${prefix}refHc`].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["2", "3", "4"].includes(modelRef.refRequestType?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return [`${prefix}lastStatus.forRequestRemark.0.remark`].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (modelRef.isOfficerCreate) {
                    common.disabled = true;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [`${prefix}lastStatus.forReceiveRemark.0.remark`].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    undefined,
                    "draft",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refHcTemp\\.(refInform)$`, "g").test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refHcTemp\\.(receiveName|receiveAddrEn|portOfDischarge|reportRemark)$`, "g").test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^${prefixRegExp}refHcTemp\\.refInform\\.(importExportDate|refTransportByWay|refTransportObjective|vehicleNo|containerNo|sealNo|refOriginDestinationCountry|refImportCheckpoint|refExportCheckpoint|refPassCustoms)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refHcTemp\\.addresses\\.[^\\.]+\\.(refAddressType|tel|fax|latitude|longitude|map)$`, "g").test(
                    field?.key
                );
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^${prefixRegExp}refHcTemp\\.addresses\\.[^\\.]+\\.(noTh|roomTh|buildingTh|floorTh|villageTh|mooTh|soiTh|roadTh|refProvince|refAmphur|refTambon|postCode)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refHcTemp\\.products\\.[^\\.]+\\.(isHc)$`, "g").test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["2", "3", "4"]
            }),
            checkboxField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^${prefixRegExp}refHcTemp\\.products\\.[^\\.]+\\.refInformProduct\\.(isCheck|isSequestrate|isSampling)$`,
                    "g"
                ).test(field?.key);
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^${prefixRegExp}refHcTemp\\.products\\.[^\\.]+\\.refInformProduct\\.(refHazSpecies|refHaz|(refHazLicense\\.approveCode)|invoiceDate|invoiceSeq|nature|quantityRemaining)$`,
                    "g"
                ).test(field?.key);
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^${prefixRegExp}refHcTemp\\.products\\.[^\\.]+\\.refInformProduct\\.(isCheck|refHazObject|refOriginDestinationCountry|formula|manufacturer|tradeName|refCoordinateCustoms|invoiceCode|(refHaz\\.tradeNameTh))$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            },
            checkboxField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refHcTemp\\.products\\.[^\\.]+\\.refInformProduct\\.(storageName|refStorageLocation)$`, "g").test(
                    field?.key
                );
            },
            visibleField: ({ model }) => {
                return !!model.refStorageLocation;
            },
            inputPropField: () => {
                return { disabled: true };
            },
            checkboxField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^${prefixRegExp}refHcTemp\\.products\\.[^\\.]+\\.productQties\\.[^\\.]+\\.(refStorageLocation|refStorageLocationSub|qty|refQtyUnit|netWeight|refNetWeightUnit|refPackagingCharacteristic|numberOfPackage|refPackageUnit|packageSize|amount)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}refHcTemp\\.declarations\\.[^\\.]+\\.(isCheck|name)$`, "g").test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["2", "3", "4"]
            }),
            checkboxField: commonInputPropField({
                disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^${prefixRegExp}refHcTemp\\.attachments\\.[^\\.]+\\.(documentName|(attribute\\.(documentNo|documentDate|documentExpiredDate))|size)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: ({ modelRef, initialModel, record }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                        if (record?.attribute?.isDisabledDocumentName) {
                            common.disabled = true;
                        }
                    }
                }
                return common;
            }
        },
        {
            check: ({ componentKey }) => {
                return new RegExp(`^${prefixRegExp}InformProductList|InformProductQtyList|DeclarationList$`, "g").test(componentKey);
            },
            inputPropField: () => {
                return { canCreate: false, canDelete: false };
            }
        },
        {
            check: ({ componentKey }) => {
                return ["AttachmentInlineList"].includes(componentKey);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly } = props;
                let canCreate = false;
                let canDelete = false;
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(initialModel.refStatus?.key)) {
                    canCreate = !viewOnly || canCreate;
                    canDelete = !viewOnly || canDelete;
                }
                return { canCreate, canDelete };
            }
        }
    ];
};
